import { useState, useEffect, useContext, useCallback  } from 'react';
import { useParams } from "react-router-dom";
import axios from 'axios';


import { CcTitle } from '../commonComponents/styledTexts';
import { Icon as Iconify } from '@iconify/react';

import ReportSnippetInfo from './snippetInfo';
import { ReportBar } from './reportBar';
import { WindowIcon } from '@heroicons/react/20/solid';


const ImageClicksViewer = (props) => {
  const [data, setData] = useState([])
  const [winnerIndex, setWinnerIndex] = useState(0)

  useEffect(() => {
    if (props.pollsStats) {
      let maxClicks = 0;
      let newWinnerIndex = 0;

      const newData = []
      
      props.pollsStats.forEach((stat) => {
        const currentStat = {...stat}
        if (currentStat.totalClicks > maxClicks) {
          maxClicks = currentStat.totalClicks
          newWinnerIndex = currentStat.answerIndex
        }
        
        newData.push(currentStat);
      });
      setData(newData)
      setWinnerIndex(newWinnerIndex)
      
      console.log(newWinnerIndex)
    }

  }, [props.pollsStats])

  return <div className='flex flex-row flex-wrap gap-4'>
      {data.map(d => <div className='flex flex-col gap-y-1 items-center relative'>
        {winnerIndex === d.answerIndex && <div className='absolute -right-2 -top-4 z-10'>
                  <img className='w-[64px]' src='/assets/winner.png' />
                </div>
        }

        <div className='bg-slate-200 rounded p-4 mt-2 w-[400px] h-[300px] flex justify-center'>
            <div className='relative h-full' >

                <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${d.imageDataUrl}`} />
            </div>
          </div>
          <div className='bg-ccColorDarkTeal text-white font-semibold font-poppins text-sm w-fit rounded px-2 py-1'>Clicks: {d.totalClicks}</div>        
      </div>)

      }
  </div>
}

export default function SnippetPollReport(props) {
    const [showLoader, setShowLoader] = useState(false)
    const [snippetInfo, setSnippetInfo] = useState(undefined)
    const [snippetBaseStats, setSnippetBaseStats] = useState(undefined)
    const [pollsStats, setPollsStats] = useState(undefined)
    const [pollsStatsTotalClicks, setPollsStatsTotalClicks] = useState(0)
    //const [pollsStatsWinnerIndex, setPollsStatsWinnerIndex] = useState(0)
    const [pollsStatsNumItems, setPollsStatsNumItems] = useState(0)

  let params = useParams();
      
  useEffect(() => {
      //console.log(params)
    if (params.snippetId !== undefined) {
        setSnippetBaseStats(undefined)
        setPollsStatsTotalClicks(0)
        setSnippetInfo(undefined)
        getSnippetBaseStats(params.snippetId)
        getSnippetPollStats(params.snippetId)
        getSnippetInfo(params.snippetId)
    }
  }, [params])

  const getSnippetBaseStats = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Stats/element/base/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      setSnippetBaseStats(data)


    } catch (error) {
      console.log(error);
    }
  }
  const getSnippetPollStats = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Stats/element/polls/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      //console.log(data)
      parsePollsStats(data)
      setPollsStats(data)


    } catch (error) {
      console.log(error);
    }
  }
  const getSnippetInfo = async (snippetId) => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
      const response = await axios.get(url);
      const data = response.data;

      //console.log(data)
      setSnippetInfo(data)  


    } catch (error) {
      console.log(error);
    }
  }
  const parsePollsStats = (stats) => {

    let totalClicks = 0;
    //let winnerIndex = 0;
    let winnerTotalClicks = 0;
    for (const row of stats) {
        totalClicks += row.totalClicks
        if (row.totalClicks > winnerTotalClicks) {
            winnerTotalClicks = row.totalClicks
            //winnerIndex = row.answerIndex
        }
    }
    setPollsStatsTotalClicks(totalClicks)
    //setPollsStatsWinnerIndex(winnerIndex)
    setPollsStatsNumItems(stats.length)
  }

  const getTitle = () => {
    switch (props.snippetTypeId) {
        case 5:
            return "Live Poll Report"
        case 6:
            return "Click Counter Report"
        case 7:
            return "Live Mood Meter Report"
        default:
        return "Element Report"
    }
  }
  const getTitleNumberOfItems = () => {
    switch (props.snippetTypeId) {
        case 5:
            return "Number of Poll Options"
        case 6:
            return "Number of Click Options"
        case 7:
            return "Number of Vote Options"
        default:
        return "Number of Options"
    }
  }

    return <div>
            <CcTitle>{getTitle()}</CcTitle>
            <div className='mt-4'>
                <ReportSnippetInfo snippetInfo={snippetInfo} />
            </div>
            <div className='mt-4'>
                <ReportBar stats={[{title: 'Image Views', value: snippetBaseStats ? snippetBaseStats.totalOpens : undefined },
                                    {title: 'Total Clicks', value: pollsStatsTotalClicks},
                                    {title: getTitleNumberOfItems(), value: pollsStatsNumItems},
                                    ]} />
            </div>
            <div className='mt-6 text-xl text-ccColorDarkTeal font-semibold'>Click Breakdown</div>
            <ImageClicksViewer pollsStats={pollsStats} />
    </div>
}